import { map } from "lodash";
import React, { Component } from "react";
import AddNote from "./AddNote";
import LogCall from "./LogCall";
import Activity from './Activity';
import noteAdd from '../../../../../Assets/images/note-add-green.svg';
import phone from '../../../../../Assets/images/phone-green.svg';
import history from '../../../../../Assets/images/history-green.svg';
import chevronRight from '../../../../../Assets/images/double chevron-right.svg';

const tabs = [{tabName:'Add Note', imageSrc: noteAdd}, {tabName:'Log Call', imageSrc: phone}, {tabName:'Activity', imageSrc: history}];

class CustomDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0,
      callLog: {}
    };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({loader: false});
    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0
      && JSON.stringify(nextProps?.CallLog?.logList) !== JSON.stringify(this.props?.CallLog?.logList)) {
      this.setState({callLog: nextProps?.CallLog?.logList});
    }
  }

  // tab change
  tabChange = (e) => {
    this.setState({ currentTab: e });
  };

  // render tab
  renderTab = () => {
    const { currentTab } = this.state;

    switch (currentTab) {
    case 0:
      return <AddNote
        customerId={this.props.customerId}
        getAccountNotes={this.props.getAccountNotes}
        addAccountNotes={this.props.addAccountNotes}
        AccountNotes={this.props.AccountNotes}
        collapse={this.collapse}
      />;
    case 1:
      return <LogCall
        customerId={this.props.customerId}
        CallLog={this.props.CallLog}
        getCallLogList={this.props.getCallLogList}
        addCallLog={this.props.addCallLog}
        updateCallLog={this.props.updateCallLog}
        RepresentativeList={this.props.RepresentativeList} // reducer
        getRepresentativeList={this.props.getRepresentativeList}
        collapse={this.collapse}
      />;
    case 2:
      return <Activity
      />;
    default:
      return <AddNote
        customerId={this.props.customerId}
        getAccountNotes={this.props.getAccountNotes}
        addAccountNotes={this.props.addAccountNotes}
        AccountNotes={this.props.AccountNotes}
        collapse={this.collapse}
      />;
    }
  };

  collapse = () => {
    this.props.expandCollapse(false);
  }

  render() {
    const { currentTab } = this.state;
    return (
      <div className="drawer-wrapper">
        <div className="page-side rdrawer">
          <div className="side-header">
            <ul className="tabs white">
              {
                map(tabs, (item, index) =>
                  <li key={`tab${index}`} className={currentTab === index ? 'active' : ''} onClick={(e) => {e.preventDefault(); this.tabChange(index) }}>
                    <span><img src={item?.imageSrc} alt="" /> {item?.tabName}</span>
                  </li>
                )
              }
              <li><img src={chevronRight} alt="" onClick={ () => { this.collapse() } } ></img></li>
            </ul>
          </div>
          <div className="card-row">
            <div className="side-body card-full">
              {this.renderTab()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomDrawer;
